export default function DSA_Tabulation() {
  return <div>DSA_Tabulation Component</div>;
}
